import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { Audio } from "@components/PreviewComponents/Audio";
import { Image } from "@components/PreviewComponents/Image";
import { ScrollingText } from "@components/PreviewComponents/ScrollingText";
import { Streaming } from "@components/PreviewComponents/Streaming";
import { Video } from "@components/PreviewComponents/Video";
import { Website } from "@components/PreviewComponents/Website";
import { YoutubeLive } from "@components/PreviewComponents/YoutubeLive";

const Container = styled.div`
  position: absolute;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  top: ${({ y = "0" }) => y}px;
  left: ${({ x = "0" }) => x}px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${({ index = 1 }) => 900 - index};
`;

export const BlockItem = ({
  block,
  index,
  playCampaignCount,
  handleNextMediaRef,
}) => {
  const [mediaIndex, setMediaIndex] = useState(0);
  const [mediaElapsedTime, setMediaElapsedTime] = useState(0);
  const intervalRef = useRef(null);
  const currentMedia = _.get(block, [
    "importantCampaignBlockMedias",
    mediaIndex,
  ]);

  const handleNextMedia = () => {
    setMediaElapsedTime(0);
    setMediaIndex((prevIndex) => {
      console.log("prevIndex :>> ", prevIndex);
      return (prevIndex + 1) % _.size(block?.importantCampaignBlockMedias);
    });
  };

  useEffect(() => {
    setMediaIndex(0);
    setMediaElapsedTime(0);
  }, [playCampaignCount]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleNextMedia();
    }, currentMedia?.duration * 1000);

    if (handleNextMediaRef) {
      handleNextMediaRef(handleNextMedia);
    }

    intervalRef.current = setInterval(() => {
      setMediaElapsedTime((prev) => prev + 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(intervalRef.current);
    };
  }, [mediaIndex, playCampaignCount]);

  return (
    <Container
      index={index}
      width={_.get(block, ["width"])}
      height={_.get(block, ["height"])}
      x={_.get(block, ["position_x"])}
      y={_.get(block, ["position_y"])}
    >
      <div key={mediaIndex} style={{ width: "100%", height: "100%" }}>
        {(() => {
          const mediaType = _.get(currentMedia, ["type"]);
          const attribute = _.get(currentMedia, ["attribute"]);
          const id = _.get(currentMedia, ["id"]);
          switch (mediaType) {
            case "image":
              return <Image key={id} attribute={attribute} />;
            case "video":
              return (
                <Video
                  key={id}
                  attribute={attribute}
                  width={_.get(block, ["width"])}
                  height={_.get(block, ["height"])}
                />
              );
            case "audio":
              return <Audio key={id} attribute={attribute} />;
            case "website":
              return <Website key={id} attribute={attribute} />;
            case "youtube-live":
              return (
                <YoutubeLive
                  key={id}
                  attribute={attribute}
                  width={_.get(block, ["width"])}
                  height={_.get(block, ["height"])}
                />
              );
            case "running-text":
              return <ScrollingText key={id} attribute={attribute} />;

            case "video-streaming":
              return <Streaming key={id} attribute={attribute} />;

            default:
              return null;
          }
        })()}
      </div>
    </Container>
  );
};
